import { useEffect } from 'react';

import { logError } from '../analytics/analytics';

export function useFirestoreError(context: string, error: Error | null | undefined): void {
  useEffect(() => {
    if (error) logError(context, error);
  }, [context, error]);
}
